import React from 'react';
import { Button, Grid, CircularProgress } from '@mui/material';
import {
    SimpleDialog,
    ButtonLoading
} from 'components';

import { makeStyles, withStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => {
    return {

        customContent: {
            // minWidth: 440,
            // //maxHeight: '400px',
            // padding: theme.spacing(2),
            // paddingTop: 0,
            // [theme.breakpoints.down('xs')]: {
            //     minWidth: 'auto',
            // },
        },

    };
});
const WarrantyTextDg = (props) => {
    const { isOpenDg, setIsOpenDg, data } = props;
    const classes = useStyles();
    return (


        <SimpleDialog
            fullWidth
            maxWidth="sm"
            customClass={classes.customContent}
            open={isOpenDg}
            title="قوانین  و مقررات صدور ضمانت‌نامه "
            onClose={() => setIsOpenDg(false)}

        >
    
            <Grid container alignItems="center" >
                <Grid style={{ position: 'relative' }}>
                    <Grid style={{ textAlign: 'justify' }}>

                        <div> {data || 'وجود ندارد'}</div>

                    </Grid>
                    <Grid md={12} xs={12} lg={12}
                       style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}
                    >
                       
                            <ButtonLoading
                                style={{ width: '100%' }}
                                type="submit"
                                variant="contained"
                          
                                name="بستن"
                                onClick={() => setIsOpenDg(false)}
                            />

                       
                    </Grid>
                </Grid>
            </Grid>


        </SimpleDialog>
    )
}

export default WarrantyTextDg;

